import { usersAPI } from '@/api';
import rolePermissionMap from '../../rolesMapping.json';

const state = {
    user: {},
    roles: [],
    users: [],
};

const getters = {
    can: (state) => (permission) => {
        let isPermitted = false;
        state.roles?.forEach((role) => {
            const roleObject = rolePermissionMap[role];
            if (roleObject) {
                roleObject.actions.forEach((action) => {
                    if (action.name === permission) {
                        isPermitted = true;
                    }
                });
            }
        });
        return isPermitted;
    },
};

const mutations = {
    setCurrentUser(state, user) {
        state.user = user;
    },

    setCurrentUserRole(state, roles) {
        state.roles = roles;
    },

    setCheckUserLoggedIn(state, checkLoggedIn) {
        state.checkLoggedIn = checkLoggedIn;
    },

    setUsers(state, users) {
        state.users = users;
    },
};

const actions = {
    async getCurrentUser({ commit }) {
        const response = await usersAPI.getCurrentUserAPI();
        commit('setCurrentUser', response.data);
        return response;
    },

    async createNewUser() {
        await usersAPI.signUpUser();
    },

    async getAllUsers({ commit }, params) {
        commit('setUsers', []);
        const response = await usersAPI.getUsersAPI(params);
        commit('setUsers', response.data._embedded.users);
        return {
            users: response.data._embedded.users,
            total: response.data['bz:total_records'] || 0,
        };
    },

    async getUserRoles(_, id) {
        return await usersAPI.getUserRolesAPI(id);
    },

    async updateUserRoles(_, { id, body }) {
        return await usersAPI.updateUserRolesAPI(id, body);
    },

    async getCurrentUserRoles({ commit }) {
        const response = await usersAPI.getUserRolesAPI(state.user.userId);
        commit('setCurrentUserRole', response.data);
    },

    async uploadUser(_, body) {
        return await usersAPI.uploadUser(body);
    },

    async downloadUserTemplate() {
        return await usersAPI.downloadUserTempalte();
    },

    async downloadUserReport() {
        return await usersAPI.downloadUserReport();
    },

    async updateUserName(_, body) {
        return await usersAPI.updateUserNameAPI(state.user.userId, body);
    },

    async updateUserEmail(_, body) {
        return await usersAPI.updateUserEmailAPI(state.user.userId, body);
    },

    async createSystemUser(_, body) {
        return await usersAPI.createSystemUserAPI(body);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
